import React from 'react';

import { usePartnerActivityTemplateQuery } from 'generated/graphql';



export interface IData {
  logoUrl: string;
}

export function useQuery(storeId: string) {
  const tuple = usePartnerActivityTemplateQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        logoUrl: tuple.data?.store?.logoUrl ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
